import { $settings } from '@/provider/settings';

const debugMode = false;

const loggerOptions = {
  loggerCallback: (level: number, message: string, containsPii: boolean) => {
    const debugLevel: {
      [key: number]: 'error' | 'warn' | 'info' | 'log';
      default: 'log';
    } = {
      0: 'error',
      1: 'warn',
      2: 'info',
      default: 'log',
    };

    if (containsPii) return;

    const method = debugLevel[level] ?? debugLevel.default;
    console[method](message);
  },
  logLevel: 3,
  piiLoggingEnabled: false,
};

const { clientId, authority, redirectUri, postLogoutRedirectUri } =
  $settings.authentication;

const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri,
    postLogoutRedirectUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    asyncPopups: true,
    allowRedirectInIframe: true,
    loggerOptions: debugMode ? loggerOptions : undefined,
    windowHashTimeout: 30000,
    iframeHashTimeout: 30000,
    loadFrameTimeout: 30000,
  },
};

export default msalConfig;
